






	import Vue from 'vue';
    import TerminOverviewComp from "../../components/raid/TerminOverviewComp.vue";

    export default Vue.extend({
        name: "ArchivPage",
        components: {TerminOverviewComp},
    })
